import { render, staticRenderFns } from "./serveraudits.vue?vue&type=template&id=22e1665a&scoped=true"
import script from "./serveraudits.vue?vue&type=script&lang=js"
export * from "./serveraudits.vue?vue&type=script&lang=js"
import style0 from "./serveraudits.vue?vue&type=style&index=0&id=22e1665a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1665a",
  null
  
)

export default component.exports